<template>
    <div id="payment-success">
        <div>
            <svg-checkmark />
            <h2><strong>Thank you for subscribing!</strong></h2>
            <p>
                We are currently processing your payment.<br />
                You will be notified by email as soon as the payment is complete.<br />
                This should be done in a few minutes.
            </p>
            <router-link :to="{name: 'dashboard'}" title="Go back to your account" class="btn">Return to your account</router-link>
        </div>
    </div>
</template>

<script>
import SvgCheckmark from '@/assets/images/checkmark.svg'

export default {
    components: { SvgCheckmark }
}
</script>

<style lang="scss" scoped>
    @import '../../../public/css/vars';

    #payment-success>div {
        width: 54rem;
        margin: 0 auto;
        text-align: center;

        h2 { margin: 40px 0 }
        p { color: $link-color-secondary }

        .btn {
            padding: 15px 40px;
            margin-top: 40px;
        }

        .checkmark {
            stroke: $link-color;
            circle {stroke: $link-color;}
            margin: 0 auto;
            height: 64px;
            width: 64px;
            border-radius: 50%;
            display: block;
            stroke-width: 2;
            stroke-miterlimit: 10;

            circle {
                stroke-dasharray: 166;
                stroke-dashoffset: 166;
                stroke-width: 2;
                stroke-miterlimit: 10;
                fill: none;
                animation: animstroke 0.8s cubic-bezier(0.65, 0, 0.45, 1) 0s forwards;
            }

            path {
                transform-origin: 50% 50%;
                stroke-dasharray: 48;
                stroke-dashoffset: 48;
                animation: animstroke 0.5s cubic-bezier(0.65, 0, 0.45, 1) .6s forwards;
            }
        }

        @keyframes animstroke {
            100% { stroke-dashoffset: 0 }
        }
    }
</style>
